import React from 'react';
import CustomerRadioInput from '../../../../../inputs/customerRadioInput/CustomerRadioInput';
import useTranslation from '../../../../../../hooks/translation/useTranslation';

function ChooseSeatFormation({ totalPassengers, seatFormation, chosenRides }) {
  const { trans, configInfo } = useTranslation();

  const isGeorgian = configInfo?.countryCode === 'GE';
  const showPriceText = isGeorgian
      && chosenRides?.departure?.routeType?.code !== 'international'
      && chosenRides?.return?.routeType?.code !== 'international';
  const options = [
    {
      label: trans('automatic_selection'),
      value: 'auto',
      disabled: totalPassengers > 9,
      visible: true,
    },
    {
      label: `${trans('i_prefer_select_seats')}*`,
      value: 'select',
      disabled: totalPassengers > 9,
      visible: true,
    },
    {
      label: `${trans('i_prefer_reserve_seats')}*`,
      value: 'book',
      visible: false,
    },
  ];

  const seatFormationTexts = {
    auto: '',
    select: `*${trans('select_service_pricey')}`,
    book: `*${trans('book_service_price_text')}`,
  };

  return (
    <div className="flex flex-col gap-5">
      <div className="h-[1px] bg-gray-gr w-full opacity-30" />
      <div className="flex flex-col gap-1 w-full">
        <CustomerRadioInput name="seatFormation" options={options} />
        <p className="ml-auto my-0">
          {showPriceText && seatFormationTexts?.[seatFormation]}
        </p>
      </div>
    </div>
  );
}

export default ChooseSeatFormation;
